module.exports = __webpack_public_path__ + "static/media/World-min.7f70aa8e.png";